<template lang="pug" src="./unallocatedClients.pug"></template>
<style lang="scss" src="./unallocatedClients.scss" scoped></style>

<script>
import { mapState } from 'vuex'
import overviewCard from '../../components/OverviewCard'

export default {
    components: {
        'overview-card': overviewCard
    },
    data: () => ({
        newFee: null,
        dialog: false,
        resetServerId: null
    }),
    computed: {
        ...mapState({
            isLoaded: (state) => state.unallocatedClients.isLoaded,
            servers: (state) => state.unallocatedClients.servers,
            clients: (state) => state.unallocatedClients.clients,
            workedServerCount: (state) => state.unallocatedClients.workedServerCount
        }),
        headers() {
            return [
                'id', 'name', 'enabled', 'apiUrl', 'apiKey',
                'balance', 'fee', 'createdAt', 'city', 'actions'
            ].map(it => Object.assign(it, {
                text: this.$vuetify.lang.t(`$vuetify.pages.UnallocatedClients.table.${it}`),
                sortable: false
            }))
        },
        overviewCards() {
            return [{
                title: 'workedServerCount',
                value: this.workedServerCount,
                icon: '/img/icons/server.svg'
            }, {
                title: 'all',
                value: this.clients.all,
                icon: '/img/icons/group.svg'
            }, {
                title: 'unallocated',
                value: this.clients.unallocated,
                icon: '/img/icons/social-care.svg'
            }, {
                title: 'allocated',
                value: this.clients.allocated,
                icon: '/img/icons/network.svg'
            }].map(({ title, value, icon }, index) => ({
                title: this.$vuetify.t(`$vuetify.pages.UnallocatedClients.cards.${title}`),
                value, icon,
                key: index
            }))
        }
    },
    created: function() {
        this.$store.dispatch('unallocatedClients/getUnallocatedData')
    },
    methods: {
        checkFee() {
            const reg = /^\d+$/
            if (!reg.test(this.newFee) || this.newFee < 0) {
                return this.$vuetify.t(`$vuetify.validate.Businesses.fee.numeric`)
            }

            return ''
        },
        onEditDialogOpen(fee) {
            this.newFee = fee || 0
        },
        async editServerFee(serverId, index) {
            if (!this.checkFee(this.newFee)) {
                const res = await this.$store.dispatch('unallocatedClients/editFee', { serverId, fee: this.newFee })

                if (res) {
                    this.servers[index].fee = this.newFee || '0'
                }
            }
            this.newFee = null
        },
        resetBalance(serverId) {
            this.dialog = true
            this.resetServerId = serverId
        },
        closeResetModal() {
            this.dialog = false
            this.resetServerId = null
        },
        async applyResetBalance() {
            const res = await this.$store.dispatch('unallocatedClients/resetBalance', this.resetServerId)

            if (res) {
                const index = this.servers.findIndex(it => it.id == this.resetServerId)

                if (index != -1) {
                    this.servers[index].balance = 0
                }
            }

            this.dialog = false
        }
    }
}
</script>

